import { GetPartnerSiteTicketUpdatesDto } from "mock-api/src/managed-receiving-global/types-v2";
import { TicketCountsPartner } from "src/app/core/ticket-counts/ticket-counts-partner.model";
import { TicketCountsBookmark } from "./ticket-counts-bookmark.model";

export class TicketCounts {
  private constructor(args: ClassProperties<TicketCounts>) {
    this.totalCount = args.totalCount;
    this.totalOpenTicketsCount = args.totalOpenTicketsCount;
    this.totalUnassignedTicketsCount = args.totalUnassignedTicketsCount;
    this.totalYourTicketsCount = args.totalYourTicketsCount;
    this.totalAutoApprovedReservationsCount =
      args.totalAutoApprovedReservationsCount;
    this.partners = args.partners;
    this.bookmarks = args.bookmarks;
  }

  public readonly bookmarks: readonly TicketCountsBookmark[];
  public readonly partners: readonly TicketCountsPartner[];
  public readonly totalAutoApprovedReservationsCount: number;
  public readonly totalCount: number;
  public readonly totalOpenTicketsCount: number;
  public readonly totalUnassignedTicketsCount: number;
  public readonly totalYourTicketsCount: number;

  public static deserialize(
    apiModel: GetPartnerSiteTicketUpdatesDto,
  ): TicketCounts {
    return new TicketCounts({
      bookmarks: TicketCountsBookmark.deserializeList(apiModel.bookmarks),
      partners: TicketCountsPartner.deserializeList(apiModel.partners),
      totalAutoApprovedReservationsCount:
        apiModel.totalAutoApprovedReservationsCount,
      totalCount: apiModel.totalCount,
      totalOpenTicketsCount: apiModel.totalOpenTicketsCount,
      totalUnassignedTicketsCount: apiModel.totalUnassignedTicketsCount,
      totalYourTicketsCount: apiModel.totalYourTicketsCount,
    });
  }

  public static deserializeList(
    apiModel: readonly GetPartnerSiteTicketUpdatesDto[],
  ): readonly TicketCounts[] {
    return apiModel.map(TicketCounts.deserialize);
  }
}
